import { BaseHit } from "instantsearch.js";
import { useRouter } from "next/router";
import { FC, KeyboardEvent, useRef, useState } from "react";
import { useHits, useSearchBox } from "react-instantsearch";
import { pagesPath } from "@/lib/$path";
import { AlgoliaTechBlog } from "@/lib/algolia";
import { SearchHits } from "../SearchHits/SearchHits";
import { SearchIcon } from "../SearchIcon/SearchIcon";
import { SearchBox } from "./SearchBox/SearchBox";

export const PcSearch: FC = () => {
  const { hits } = useHits<BaseHit & AlgoliaTechBlog>();
  const { refine } = useSearchBox();
  const router = useRouter();
  const [selectedId, setSelectedId] = useState("");
  const [isShow, setIsShow] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      const currentIndex = hits.findIndex((hit) => hit.objectID === selectedId);
      const step = e.key === "ArrowDown" ? 1 : -1;
      const nextIndex = (hits.length + currentIndex + step) % hits.length;
      setSelectedId(hits[nextIndex]?.objectID);
    } else if (e.key === "Enter") {
      const hit = hits.find((h) => h.objectID === selectedId);

      if (hit) void router.push(pagesPath.kdotdev._slug(String(hit?.slug)).$url());
    }
  };

  return (
    <div className="relative ml-auto hidden md:block">
      <SearchIcon
        fill="#fff"
        className="cursor-pointer"
        onClick={() => {
          refine("");
          setIsShow(true);
          setTimeout(() => {
            inputRef.current?.focus();
          });
        }}
      />

      {isShow && (
        <div
          className="fixed left-0 top-0 z-[1001] flex h-screen w-screen justify-center bg-[#0000006a]"
          aria-hidden="true"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setIsShow(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setIsShow(false);
            }
          }}
        >
          <div className="mb-auto mt-[128px] w-[769px] overflow-hidden rounded-[16px] bg-white">
            <SearchBox inputRef={inputRef} onChange={(value) => refine(value)} onKeyDown={onKeyDown} />
            <SearchHits selectedId={selectedId} className="scrollbar-none max-h-[500px] w-full overflow-y-auto p-1" />
          </div>
        </div>
      )}
    </div>
  );
};
